import React from "react";

export default function StatusPill({ status }) {
  if (!status) return null;
  const testId = `project-status-${status.toLowerCase().replace(/[^a-z]+/g, "-")}`;
  return (
    <span
      data-testid={testId}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "6px 12px",
        borderRadius: 999,
        border: "1px solid var(--sokno-line-strong)",
        background: "rgba(214, 175, 99, 0.06)",
        color: "var(--sokno-gold-warm)",
        fontFamily: "'Cinzel', serif",
        fontSize: 10,
        letterSpacing: "0.24em",
        textTransform: "uppercase",
        whiteSpace: "nowrap",
      }}
    >
      <span
        aria-hidden
        style={{
          width: 6,
          height: 6,
          borderRadius: 999,
          background: "var(--sokno-gold)",
          boxShadow: "0 0 8px var(--sokno-gold-glow)",
        }}
      />
      {status}
    </span>
  );
}
